import React from "react";
import { User } from "lucide-react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import ProfileCardTenant from "src/components/cards/ProfileCardTenant";

const SettingsProfilePage: React.FC = () => {
  return (
    <DashboardLayout
      meta={{
        title: "Profile | Invyntra",
        description: "View and update your personal profile details.",
        keywords: "profile, settings, account, invyntra",
      }}
    >
      <div className="mx-auto max-w-3xl space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <User size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Profile
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Your personal details, visible only to you and your team.
            </p>
          </div>
        </div>

        <Card>
          <ProfileCardTenant />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SettingsProfilePage;
